import ModalSuccess from "./modalMessage";

export default ModalSuccess;
